import { render, staticRenderFns } from "./DiagensBanner.vue?vue&type=template&id=3a23df08&scoped=true"
import script from "./DiagensBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagensBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DiagensBanner.vue?vue&type=style&index=0&id=3a23df08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23df08",
  null
  
)

export default component.exports